export default {
  package: undefined, // apiStore.getItem('package') // * object
  licenseStartDate: undefined, // date // * String
  licenseExpiry: undefined, // date // * String
  selectedPackageId: undefined, // id
};
